// Coco 9 — minimal client JS
// Cart drawer + add-to-cart are handled entirely by snippets/cart-drawer.liquid
// (it has its own self-contained script). This file handles the rest:
// variant pickers, gallery thumbnails, product tabs, and the qty stepper.
(() => {
  const $  = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];

  // ─── Variant pickers (radio-style buttons) ───────────────────────────
  $$('[data-variants]').forEach(group => {
    const buttons = $$('button[data-variant-id]', group);
    const input = $(group.dataset.variants);
    buttons.forEach(b => b.addEventListener('click', () => {
      buttons.forEach(x => x.setAttribute('aria-current', 'false'));
      b.setAttribute('aria-current', 'true');
      if (input) input.value = b.dataset.variantId;
      // Update price
      const price = b.dataset.price;
      const display = $('[data-price]');
      if (display && price) display.textContent = price;
    }));
  });

  // ─── Gallery thumbnails ───────────────────────────────────────────────
  $$('[data-gallery]').forEach(g => {
    const main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(t => {
      t.addEventListener('click', () => {
        g.querySelectorAll('[data-gallery-thumb]').forEach(x => x.setAttribute('aria-current', 'false'));
        t.setAttribute('aria-current', 'true');
        if (main) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = t.dataset.full || t.querySelector('img').src; }
      });
    });
  });

  // ─── Tabs ─────────────────────────────────────────────────────────────
  $$('[data-tabs]').forEach(tabs => {
    const navs = $$('[data-tab]', tabs);
    const panels = $$('[data-panel]', tabs);
    navs.forEach(n => n.addEventListener('click', () => {
      navs.forEach(x => x.setAttribute('aria-current', 'false'));
      panels.forEach(p => p.hidden = true);
      n.setAttribute('aria-current', 'true');
      const panel = panels.find(p => p.dataset.panel === n.dataset.tab);
      if (panel) panel.hidden = false;
    }));
  });

  // ─── Qty stepper ──────────────────────────────────────────────────────
  $$('.pdp__qty').forEach(q => {
    const input = q.querySelector('input');
    q.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
      const delta = b.dataset.delta === '-1' ? -1 : 1;
      input.value = Math.max(1, parseInt(input.value || 1) + delta);
    }));
  });
})();
